import styled from "styled-components";
import { Select } from "antd";

// Estilos exclusivos para o select múltiplo do relatório
export const ReportMultiSelectStyles = `
  &.ant-select-multiple .ant-select-selector {
    min-height: 35px !important;
    height: auto !important;
    padding: 4px 12px !important;
  }

  &.ant-select-multiple .ant-select-selection-overflow {
    flex-wrap: wrap !important;
    gap: 4px !important;
  }

  &.ant-select-multiple .ant-select-selection-item {
    background-color: rgba(240, 240, 240, 1) !important;
    border: 1px solid rgba(217, 217, 217, 1) !important;
    border-radius: 4px !important;
    padding: 0px 10px !important;
    font-size: 13px !important;
    margin: 5px 0 !important;
    display: flex !important;
    min-height: 28px !important;
    align-items: center !important;
  }

  &.ant-select-multiple .ant-select-arrow {
    display: flex !important;
  }
`;

// Styled Select para o relatório, aplicando os estilos acima
export const ReportMultiSelect = styled(Select)`
  width: 100%;
  ${ReportMultiSelectStyles}
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 21px;
  padding-left: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const SubmitContainer = styled.div`
  flex: 0 0 auto;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const FieldsContainer = styled.div`
  margin-top: 16px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #444;
  margin-bottom: 8px;
`;

export const FilterActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  flex-wrap: wrap;
  margin-top: 24px;
  gap: 8px;

  @media (max-width: 500px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const GoBackContainer = styled.div`
  flex: 0 0 auto;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 14px;
  font-weight: normal;
`;
